import { render, staticRenderFns } from "./UploadManager.vue?vue&type=template&id=4c8aa3fa&scoped=true&"
import script from "./UploadManager.vue?vue&type=script&lang=js&"
export * from "./UploadManager.vue?vue&type=script&lang=js&"
import style0 from "./UploadManager.vue?vue&type=style&index=0&id=4c8aa3fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8aa3fa",
  null
  
)

export default component.exports